export class SmartphotoInformation {
    static DEFAULT_INFORMATION = {
        pages: [
            {
                mandatory: true,
                name: 'landing',
                order: 0,
                show: true
            },
            {
                mandatory: true,
                name: 'information-form',
                order: 1,
                show: true
            },
            {
                mandatory: true,
                name: 'car-parts',
                order: 2,
                show: true
            },
            {
                mandatory: false,
                name: 'damage-pictures',
                order: 3,
                photosQuantity: 4,
                show: true
            },
            {
                mandatory: true,
                name: 'side-pictures',
                order: 4,
                photosQuantity: 6,
                show: true,
                showDescriptionModal: true,
                plateType: 'normal'
            },
            {
                mandatory: true,
                name: 'document-pictures',
                order: 5,
                photosQuantity: 4,
                show: true
            },
            {
                mandatory: true,
                name: 'signature',
                order: 6,
                show: true
            },
            {
                mandatory: true,
                name: 'feedback',
                order: 7,
                show: true
            },
            {
                mandatory: true,
                name: 'final',
                order: 8,
                show: true
            }
        ]
    };
    pages = [];
    constructor(selfadjustInfo, smartphotoTemplate) {
        const information = selfadjustInfo ?? SmartphotoInformation.DEFAULT_INFORMATION;
        const template = smartphotoTemplate ?? selfadjustInfo?.defaultTemplate;
        const actualPages = template && !Array.isArray(information.pages) ? information.pages[template].pages : information.pages;
        if (Array.isArray(actualPages)) {
            this.pages = JSON.parse(JSON.stringify(actualPages.filter(({ show }) => Boolean(show))));
        }
    }
}
